import cn from 'classnames';

import { IconX } from 'components/UI/Icons/X';
import { Chip } from 'components/UI/Tailwind/Chip';

type ChipProps = React.ComponentProps<typeof Chip>;
type TButton = JSX.IntrinsicElements['button'];
type TInput = JSX.IntrinsicElements['input'];

export interface TagList
  extends Pick<TButton, 'children' | 'className' | 'disabled'>,
    Pick<TInput, 'placeholder'> {
  editable?: boolean;
  ellipsis?: boolean;
  onDeleteTag?: (index: number) => void;
  tagSize?: ChipProps['size'];
  tags: string[];
}

export function TagList({
  children,
  className,
  disabled,
  editable = false,
  ellipsis,
  onDeleteTag,
  placeholder,
  tagSize = 26,
  tags,
}: TagList) {
  return (
    <div
      className={cn(
        'flex flex-wrap gap-x-2 gap-y-1 overflow-hidden',
        className,
      )}
    >
      {tags.map((tag, index) =>
        editable && onDeleteTag ? (
          <Chip
            key={index}
            className="text-single-line"
            disabled={disabled}
            ellipsis={ellipsis}
            iconEnd={<IconX />}
            onClick={() => onDeleteTag(index)}
            size={tagSize}
          >
            {tag}
          </Chip>
        ) : (
          <Chip
            key={index}
            className="text-single-line"
            ellipsis={ellipsis}
            size={tagSize}
          >
            {tag}
          </Chip>
        ),
      )}
      {editable && !tags.length && placeholder && (
        <span className="py-1.5 text-14/100% font-medium italic text-gray-500 opacity-30">
          {placeholder}
        </span>
      )}
      {children}
    </div>
  );
}
